import { defineMessages } from 'react-intl-next';

export default defineMessages({
	requestAccessTitle: {
		id: 'project-pages.cross-join.request-access.title',
		defaultMessage: 'Project pages require access to Confluence',
		description: 'Title for the request access view',
	},
	requestAccessTitleExp: {
		id: 'project-pages.cross-join.request-access.title.experiment',
		defaultMessage: 'Create a single source of truth for your team',
		description:
			'Title for the unified request access & direct join view in project page for cross join nudge experiment',
	},
	requestAccessWithoutBetterTogetherDescription: {
		id: 'project-pages.cross-join.request-access-without-better-together.connected.description',
		defaultMessage: 'View, edit and create project documentation with your team',
		description: 'Description for request access view when there is a Confluence space connected',
	},
	requestAccessDescriptionExp: {
		id: 'project-pages.cross-join.request-access.connected.description.experimental',
		defaultMessage:
			'Your team is using Project Pages to comment, edit, and collaborate on project documentation without leaving Jira. Join Confluence to access your team’s Project Pages.',
		description:
			'Description for request access view when there is a Confluence space connected for new cross join nudge experiment',
	},
	requestAccessButton: {
		id: 'project-pages.cross-join.request-access.button',
		defaultMessage: 'Request access',
		description: 'Button label for request access CTA',
	},
	requestAccessButtonExp: {
		id: 'project-pages.cross-join.request-access.button.experimental',
		defaultMessage: 'Join your team',
		description:
			'Button label for request access & direct join CTA for new cross join nudge experiment',
	},
	requestAccessButtonSubtitleExp: {
		id: 'project-pages.cross-join.request-access.button-subtitle.experimental',
		defaultMessage:
			"When you select 'Join Your Team', you're asking to join Confluence and agree to share your Atlassian profile with your admin.",
		description:
			'Subtitle under Join Your Team button for request access scenario for new cross join nudge experiment',
	},
	joinProductButtonDescriptionExp: {
		id: 'project-pages.cross-join.direct-access.button-subtitle.experimental',
		defaultMessage: "You'll get access to Confluence. Your site admin has already approved you.",
		description:
			'Subtitle under Join Your Team button for direct join scenario for new cross join nudge experiment',
	},
	requestAccessPendingRequestTitle: {
		id: 'project-pages.cross-join.pending-request.templates.title',
		defaultMessage: "You've requested access to Confluence",
		description:
			'Title shown when user has requested access to Confluence but the request is pending',
	},
	requestAccessPendingRequestExp: {
		id: 'project-pages.cross-join.pending-request.templates.title.experiment',
		defaultMessage: 'Access request sent to Admin',
		description:
			'Title shown when user has requested access to Confluence but the request is pending for new cross join nudge experiment',
	},
	requestAccessPendingRequestSubtitle: {
		id: 'project-pages.cross-join.pending-request.templates.subtitle',
		defaultMessage:
			"The site admin has received your request to join Confluence. If you're approved to join, project pages will start working and we'll send you a confirmation email.",
		description:
			'Long description shown when user has requested access to Confluence but the request is pending',
	},
	requestAccessPendingRequestSubtitleExp: {
		id: 'project-pages.cross-join.pending-request.templates.subtitle.experiment',
		defaultMessage: "You'll get an email with access to Project Pages once you’re approved.",
		description:
			'Long description shown when user has requested access to Confluence but the request is pending for new cross join experiment',
	},
	requestDeniedAccessRequestTitle: {
		id: 'project-pages.cross-join.denied-request.templates.title',
		defaultMessage: 'Your admin has denied you access',
		description:
			'Title shown when user has requested access to Confluence but the request is denied',
	},
	requestDeniedAccessRequestSubtitle: {
		id: 'project-pages.cross-join.denied-request.templates.subtitle',
		defaultMessage:
			"You can't use project pages because the site admin denied your request to join Confluence.",
		description:
			'Subtitle shown when user has requested access to Confluence but the request is denied',
	},
	requestAccessRevokedTitle: {
		id: 'project-pages.cross-join.access-revoked.templates.title',
		defaultMessage: "You don't have permissions to use project pages",
		description:
			'Title shown when user has requested access to Confluence but the request has since been revoked',
	},
	requestAccessRevokedSubtitle: {
		id: 'project-pages.cross-join.access-revoked.templates.subtitle',
		defaultMessage:
			'You cannot use project pages because the admin has denied you access to Confluence. Contact your site admin to request access.',
		description:
			'Subtitle shown when user has requested access to Confluence but the request has since been revoked',
	},
	viewProfile: {
		id: 'project-pages.cross-join.avatar.view-profile',
		defaultMessage: 'View profile',
	},
});
